var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-chheight wel-contailer"},[_c('div',{staticClass:"banner-text"},[_c('h2',[_vm._v(_vm._s(_vm.website.wel.title))]),_c('span',{class:['actor',{typeing:_vm.isText}]},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }